export default __webpack_public_path__ + "assets/images/b9ae4a05b3432b7eaf9b1a7533ff2dcc.png";